/// <reference lib="dom" />

/**
 * Handles Vite's preloadError events in production builds.
 * This occurs when dynamic imports fail due to hash mismatches,
 * typically after a new deployment while users are still active.
 *
 * We prevent the default error from being thrown since we're handling
 * the error by reloading the page to get the latest assets.
 */

export function setupPreloadErrorHandler(): void {
  window.addEventListener('vite:preloadError', ((event: VitePreloadErrorEvent) => {
    // Prevent the default error from being thrown
    event.preventDefault();

    console.warn('[PreloadError] Module failed to load, refreshing page...', {
      url: event.payload.name,
      message: event.payload.message,
    });

    // Reload the page to recover from the error
    setTimeout(() => {
      window.location.reload();
    }, 5000);
  }) as EventListener);
}
